import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-8 pl-5 pr-6 py-5 bg-white border shadow sm:rounded-lg border-gray-200 lg:min-w-[410px]" }
const _hoisted_2 = ["value"]

import { Component as VueComponent } from "vue";
import { useI18n } from "vue-i18n";
import { HierarchyTagStore } from "shared/types/HierarchyTag";
import { Report, ReportPlotType } from "@/types/Report";
import ReportFormSection from "@/views/reports/components/ReportFormSection.vue";
import CycleTimesForm from "@/views/reports/plots/cycle_times/CycleTimesForm.vue";
import MilestoneForm from "@/views/reports/plots/milestone/MilestoneForm.vue";
import QueryValueForm from "@/views/reports/plots/query_value/QueryValueForm.vue";
import UnitValuesForm from "@/views/reports/plots/unit_values/UnitValuesForm.vue";
import WorkingHourCurveForm from "@/views/reports/plots/working_hour_curve/WorkingHourCurveForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportForm',
  props: {
    report: {},
    hierarchyTags: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;
const emit = __emit;

const formComponents: Record<ReportPlotType, VueComponent> = {
  cycle_times: CycleTimesForm,
  working_hour_curve: WorkingHourCurveForm,
  milestone: MilestoneForm,
  unit_values: UnitValuesForm,
  query_value: QueryValueForm,
};

const handleReportNameChange = (event: Event) => {
  const name = (event.target as HTMLInputElement).value;
  emit("change", { name });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReportFormSection, {
      number: "1",
      label: _unref(t)('analytics.reports.name')
    }, {
      default: _withCtx(() => [
        _createElementVNode("input", {
          value: _ctx.report.name,
          onInput: handleReportNameChange,
          type: "text",
          autocomplete: "one-time-code",
          class: "outline-none block w-full rounded-md border-0 py-1.5 pl-3 ring-1 ring-inset focus:ring-2 focus:ring-inset text-sm sm:leading-6 text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-yellow-300 pr-10,"
        }, null, 40, _hoisted_2)
      ]),
      _: 1
    }, 8, ["label"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(formComponents[_ctx.report.type]), {
      config: _ctx.report.config,
      filters: _ctx.report.filters,
      aggregation: _ctx.report.aggregation,
      hierarchyTags: props.hierarchyTags,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('change', $event)))
    }, null, 40, ["config", "filters", "aggregation", "hierarchyTags"]))
  ]))
}
}

})